import {PureComponent} from 'react';
import {Paper} from '@material-ui/core';
import ProcessOutcomeLobbyActionToolbar from 'ProcessOutcomeLobby/Presentation/ProcessOutcomeLobbyActionToolbar';
import ProcessOutcomeList from 'ProcessOutcomeLobby/Presentation/ProcessOutcomeList';

class ProcessOutcomeLobby extends PureComponent {
  render() {
    const {props} = this;

    return (
      <div>
        <Paper>
          <ProcessOutcomeLobbyActionToolbar {...props} />
          <ProcessOutcomeList {...props} />
        </Paper>
      </div>
    );
  }
}

export default ProcessOutcomeLobby;
